import { Routes } from "@angular/router";

export default [
    { path: 'auth', loadChildren: () => import('./auth/auth.routes') },
    { path: '', loadChildren: () => import('./main/main.routes') }
] as Routes;